
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Form } from '@/components/ui/form';
import { FeedbackTypeField } from './FeedbackTypeField';
import { DescriptionField } from './DescriptionField';
import { StepsField } from './StepsField';
import { UrgencyField } from './UrgencyField';
import { ContactMethodField } from './ContactMethodField';
import { PhoneNumberField } from './PhoneNumberField';
import { ScreenshotField } from './ScreenshotField';
import { CommentsField } from './CommentsField';
import { FormActions } from './FormActions';
import { FormValues } from './types';
import { TechniqueNameField } from './TechniqueNameField';

interface FeedbackFormContentProps {
  form: UseFormReturn<FormValues>;
  screenshot: File | undefined;
  setScreenshot: React.Dispatch<React.SetStateAction<File | undefined>>;
  onSubmit: (values: FormValues) => Promise<void>;
  onCancel: () => void;
  isSubmitting?: boolean;
}

export const FeedbackFormContent: React.FC<FeedbackFormContentProps> = ({
  form,
  screenshot,
  setScreenshot,
  onSubmit,
  onCancel,
  isSubmitting = false
}) => {
  const watchType = form.watch('type');
  const watchContactMethod = form.watch('contactMethod');
  
  const isTechniqueRequest = watchType === 'Technique Request';
  
  const handleSubmit = async (values: FormValues) => {
    await onSubmit(values);
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(handleSubmit)} className="space-y-4">
        <FeedbackTypeField form={form} />
        
        {isTechniqueRequest && (
          <TechniqueNameField form={form} />
        )}
        
        <DescriptionField 
          form={form} 
          label={isTechniqueRequest ? "Technique Description" : "Description"}
          placeholder={isTechniqueRequest ? "Please describe the technique in detail" : "Please describe the issue or feature request in detail"}
        />
        
        {!isTechniqueRequest && (
          <>
            <StepsField form={form} showField={watchType === 'Bug'} />
            <UrgencyField form={form} />
            <ContactMethodField form={form} />
            <PhoneNumberField 
              form={form} 
              showField={watchContactMethod === 'Phone' || watchContactMethod === 'Either is fine'} 
            />
            <ScreenshotField 
              screenshot={screenshot} 
              setScreenshot={setScreenshot} 
            />
            <CommentsField form={form} />
          </>
        )}
        
        <FormActions onCancel={onCancel} isSubmitting={isSubmitting} />
      </form>
    </Form>
  );
};
